import StartIndex from './StartIndex';

export { type StartIndexProps } from './StartIndex';
export default StartIndex;
